export const PAYMENT_MODE = [
    {
        name: 'Debit Card',
        value: 'DC',
    },
    {
        name: 'Credit Card',
        value: 'CC',
    },
    {
        name: 'Net Banking',
        value: 'NB',
    },
    {
        name: 'UPI',
        value: 'UPI',
    },
    {
        name: 'Wallet',
        value: 'WALLET',
    },
];

export const UPLOAD_FILE_STATUS_ENUM = {
    DEFAULT: 'DEFAULT',
    UPLOADING: 'UPLOADING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};

export const SAMPLE_FILE_SCHEMA = [
    ['merchantId', 'txnReferenceId', 'refundAmount', 'currency'],
];

export const SAMPLE_FILE_NAME = 'Sample-Bulk-Upload.csv';
